import React from 'react';
import { createStackNavigator } from '@react-navigation/stack';

import { TimeClockStackParamList } from '@/types/navigation';
import TimeClockScreen from '@/screens/timeclock/TimeClockScreen';
import NfcClockScreen from '@/screens/timeclock/NfcClockScreen';
import { colors, font } from '@/theme/chalkCourt';

const Stack = createStackNavigator<TimeClockStackParamList>();

/**
 * Time Clock tab stack: the shift-aware Time Clock screen plus the NFC
 * tap screen pushed via a "Tap NFC" button. NFC used to be its own
 * bottom tab; folding it under Time Clock frees a slot for Messages.
 */
const TimeClockNavigator: React.FC = () => (
  <Stack.Navigator
    screenOptions={{
      headerStyle: { backgroundColor: colors.bg, shadowColor: 'transparent' },
      headerTintColor: colors.ink,
      headerTitleStyle: { fontFamily: font.displayBold, fontSize: 20 },
      headerBackTitleVisible: false,
      cardStyle: { backgroundColor: colors.bg },
    }}>
    <Stack.Screen
      name="TimeClockHome"
      component={TimeClockScreen}
      options={{ headerShown: false }}
    />
    <Stack.Screen name="NfcClock" component={NfcClockScreen} options={{ title: 'NFC Tap' }} />
  </Stack.Navigator>
);

export default TimeClockNavigator;
